import React from 'react'
import { Colors, Icon } from '@blueprintjs/core'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { Tooltip } from '../ui/tooltip'
import { State } from '../../constants'

const stateOptions = {
    [State.Enabled]: { title: 'Enabled', color: Colors.GREEN3 },
    [State.Paused]: { title: 'Paused', color: Colors.GRAY3 },
    [State.Archived]: { title: 'Archived', color: Colors.RED3 },
}

interface MinimalStateDotProps {
    state: number
    className?: ClassValue
}

export const MinimalStateDot = ({ state, className }: MinimalStateDotProps) => {
    if (!stateOptions[state]) {
        console.warn('Cannot pull state options for:', state)
        return null
    }

    const { color, title } = stateOptions[state]

    return (
        <Tooltip content={title} className={classNames(className)}>
            <Icon icon={<Icon icon="dot" color={color} />} />
        </Tooltip>
    )
}
